import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import {
  ACTIONS_GET_PHARMACY_ORDERS,
  ACTIONS_GET_PHARMACY_RECENT_ORDERS,
  ACTIONS_GET_PHARMACY_ORDERS_HISTORY,
  ACTIONS_GET_PHARMACY_CART_ORDER_REQUESTS,
} from "../../action-types/actions";

import i18n from "../../i18n";
export const getPharmacyOrders = createAsyncThunk(
  ACTIONS_GET_PHARMACY_ORDERS.get_pharmacy_orders,
  async (
    { page = 1, limit = 10, status = "all", search = "", date = "" },
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        status,
        search,
        date,
      });

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyOrders}?${params.toString()}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message || i18n.t("pharmacy.toast.failedToFetchPharmacyOrders"),
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorFetchingPharmacyOrders");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);

export const getPharmacyRecentOrders = createAsyncThunk(
  ACTIONS_GET_PHARMACY_RECENT_ORDERS.get_pharmacy_recent_orders,
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyRecentOrders}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(response?.data?.message || i18n.t("pharmacy.toast.failedToFetchRecentOrders"));
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorFetchingRecentOrders");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);

export const getPharmacyOrdersHistory = createAsyncThunk(
  ACTIONS_GET_PHARMACY_ORDERS_HISTORY.get_pharmacy_orders_history,
  async (
    { page = 1, limit = 8, search = "", date_from = "", date_to = "" },
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      if (search) {
        params.append("search", search);
      }

      if (date_from) {
        params.append("date_from", date_from);
      }

      if (date_to) {
        params.append("date_to", date_to);
      }

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyOrdersHistory}?${params.toString()}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message || i18n.t("pharmacy.toast.failedToFetchPharmacyOrdersHistory"),
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorFetchingPharmacyOrdersHistory");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);

export const getPharmacyCartOrderRequests = createAsyncThunk(
  ACTIONS_GET_PHARMACY_CART_ORDER_REQUESTS.get_pharmacy_cart_order_requests,
  async (
    { page = 1, limit = 8, search = "", date_from = "", date_to = "" },
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });

      if (search) {
        params.append("search", search);
      }

      if (date_from) {
        params.append("date_from", date_from);
      }

      if (date_to) {
        params.append("date_to", date_to);
      }

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyCartOrderRequests}?${params.toString()}`,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        toast.error(
          response?.data?.message || i18n.t("pharmacy.toast.failedToFetchCartOrderRequests"),
        );
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorFetchingCartOrderRequests");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
